import React, { useState, useEffect, useContext } from 'react';
import { Box, Collapsible, ResponsiveContext } from 'grommet';
import AppBar from './AppBar'
import LayoutListItem from './LayoutListItem'
import LayoutListSeparator from './LayoutListSeparator'
import { List } from './List'
import AppFooter from './AppFooter'
import AppTopTicker from './AppTopTicker'

import { EnvProvider } from '../../context/EnvContext'
import { TriageUrlProvider } from '../../context/TriageUrlContext'
import UserContext from '../../context/UserContext'

import { ToastProvider } from 'react-toast-notifications'

import { useLocation, useNavigate } from 'react-router-dom'
import envConfig from '../../utils/envConfig'

const liteMode = envConfig[process.env.REACT_APP_ENVIRONMENT]['lite']

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const UAT_ENVIRONMENTS = ["ext-uat", "ext-uat-us", "ext-uat-eu"]
const PROD_ENVIRONMENTS = ["ext-prod", "ext-prod-us", "ext-prod-eu"]
const INT_ENVIRONMENTS = ["int-dev", "int-dev-us", "int-dev-eu"]
const PREVIEW_ENVIRONMENTS = ["ext-prod-preview", "int-preview", "int-preview-us", "int-preview-eu"]

const Layout = props => {

  const token = useContext(UserContext)
  let history = useNavigate()

  const [showSidebar, setShowSidebar] = useState(true);
  const [sideBarSelected, setSideBarSelected] = useState(window.location.pathname.split('/')[1])
  const [envSelected, setEnvSelected] = useState("")
  const t3Url = envConfig[process.env.REACT_APP_ENVIRONMENT]['t3_url']

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar)
  }

  const handleWindowResize = () => {
    if (window.innerWidth < 400) {
      setShowSidebar(false)
    }
  }

  const handleEnvSelect = option => {
    setEnvSelected("")
    setEnvSelected(option)
    history('?env=' + option)
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    }
  });

  // Set Envselected to Query Param Param
  const query = useQuery();
  const envURL = query.get("env")

  useEffect(() => {
    if (envURL) {
      setEnvSelected(envURL)
    }
  }, [envURL])

  const handleClickSidebar = (newItemText) => {
    setSideBarSelected(newItemText)
  }

  return (
    <>
      <ToastProvider autoDismissTimeout={8000}>
        <ResponsiveContext.Consumer>
          {size => (
            <Box fill>
              <AppTopTicker />
              <AppBar
                toggleSidebar={toggleSidebar}
                handleClickSidebar={() => handleClickSidebar('')}
                handleLogout={props.handleLogout}
                envSelected={envSelected}
                handleEnvSelect={handleEnvSelect}
              />
              <Box direction='row' flex overflow={{ horizontal: 'hidden' }}>
                <Collapsible direction="horizontal" open={showSidebar}>
                  <Box
                    flex
                    width='160px'
                    background='light-2'
                    elevation='small'
                    align='center'
                    justify='center'
                    gap="small"
                  >
                    <List>
                      <LayoutListItem itemText={'Home'} itemIcon={'home'} itemLink={'/'} sideBarSelected={sideBarSelected} handleClickSidebar={() => handleClickSidebar('')} />

                      <LayoutListSeparator itemText={'Health'} />

                      <LayoutListItem itemText={'Status'} itemIcon={'health'} itemLink={'/health/status'} sideBarSelected={sideBarSelected} handleClickSidebar={() => handleClickSidebar('health')} />
                      <LayoutListItem itemText={'Observability'} itemIcon={'observability'} itemLink={'/observability'} sideBarSelected={sideBarSelected} handleClickSidebar={() => handleClickSidebar('observability')} />
                      <LayoutListItem itemText={'Alerts'} itemIcon={'alert'} itemLink={'/alert'} sideBarSelected={sideBarSelected} handleClickSidebar={() => handleClickSidebar('alert')} />

                      {!liteMode &&
                        <LayoutListItem itemText={'Notifications'} itemIcon={'notification'} itemLink={'/notifications/active'} sideBarSelected={sideBarSelected} handleClickSidebar={() => handleClickSidebar('notifications')} />
                      }

                      <LayoutListItem itemText={'ZK Live Data'} itemIcon={'data'} itemLink={'/data/home'} sideBarSelected={sideBarSelected} handleClickSidebar={() => handleClickSidebar('data')} />
                      <LayoutListItem itemText={'ZK History'} itemIcon={'history'} itemLink={'/zkhistory'} sideBarSelected={sideBarSelected} handleClickSidebar={() => handleClickSidebar('zkhistory')} />
                      <LayoutListItem itemText={'Sessions'} itemIcon={'ttus'} itemLink={'/sessions/connections'} sideBarSelected={sideBarSelected} handleClickSidebar={() => handleClickSidebar('sessions')} />

                      <LayoutListSeparator itemText={'Components'} />

                      {
                        !liteMode &&
                        <LayoutListItem itemText={'AWS'} itemIcon={'market'} itemLink={'/aws/route53'} sideBarSelected={sideBarSelected} handleClickSidebar={() => handleClickSidebar('aws')} />
                      }

                      {(process.env.REACT_APP_ENVIRONMENT === 'local-prod' || envConfig[process.env.REACT_APP_ENVIRONMENT]['lite'] || process.env.REACT_APP_ENVIRONMENT?.startsWith("ext-prod") || process.env.REACT_APP_ENVIRONMENT?.startsWith("ext-uat")) &&
                        <LayoutListItem itemText={'Bouncer'} itemIcon={'bouncer'} itemLink={'/bouncer/health'} sideBarSelected={sideBarSelected} handleClickSidebar={() => handleClickSidebar('bouncer')} />
                      }

                      <LayoutListItem itemText={'FIX'} itemIcon={'fix'} itemLink={'/fix/parser'} sideBarSelected={sideBarSelected} handleClickSidebar={() => handleClickSidebar('fix')} />
                      <LayoutListItem itemText={'FIX Orders GW'} itemIcon={'bankalgo'} itemLink={'/fixgworders/mapping'} sideBarSelected={sideBarSelected} handleClickSidebar={() => handleClickSidebar('fixgworders')} />

                      <LayoutListItem itemText={'Markets'} itemIcon={'market'} itemLink={'/market/schedule'} sideBarSelected={sideBarSelected} handleClickSidebar={() => handleClickSidebar('market')} />
                      <LayoutListItem itemText={'PDS'} itemIcon={'product'} itemLink={'/products/pds'} sideBarSelected={sideBarSelected} handleClickSidebar={() => handleClickSidebar('products')} />

                      <LayoutListSeparator itemText={'Applications'} />

                      {!liteMode &&
                        <LayoutListItem itemText={'Triage'} itemIcon={'triage'} itemLink={'/triage/commands'} sideBarSelected={sideBarSelected} handleClickSidebar={() => handleClickSidebar('triage')} />
                      }

                      {!liteMode &&
                        <LayoutListItem itemText={'Smoke Tests'} itemIcon={'smoketest'} itemLink={'/smoketest/results'} sideBarSelected={sideBarSelected} handleClickSidebar={() => handleClickSidebar('smoketest')} />
                      }

                      {(process.env.REACT_APP_ENVIRONMENT === 'local-prod' || process.env.REACT_APP_ENVIRONMENT === 'local' || liteMode) &&
                        <>
                          <LayoutListSeparator itemText={'SRE'} />
                          <LayoutListItem itemText={'Actions'} itemIcon={'actions'} itemLink={'/sre/actions'} sideBarSelected={sideBarSelected} handleClickSidebar={() => handleClickSidebar('sre')} />
                        </>
                      }

                      {!liteMode && token && token.scopes && token.scopes.indexOf("triage/ad") !== -1 && (
                        PROD_ENVIRONMENTS.includes(process.env.REACT_APP_ENVIRONMENT) ||
                        UAT_ENVIRONMENTS.includes(process.env.REACT_APP_ENVIRONMENT) ||
                        INT_ENVIRONMENTS.includes(process.env.REACT_APP_ENVIRONMENT) ||
                        PREVIEW_ENVIRONMENTS.includes(process.env.REACT_APP_ENVIRONMENT) ||
                        process.env.REACT_APP_ENVIRONMENT === 'local' ||
                        process.env.REACT_APP_ENVIRONMENT === 'local-prod'
                      ) &&
                        <>
                          <LayoutListItem itemText={'Admin'} itemIcon={'admin'} itemLink={'/admin/home'} sideBarSelected={sideBarSelected} handleClickSidebar={() => handleClickSidebar('admin')} />
                        </>
                      }

                    </List>
                  </Box>
                </Collapsible>
                <Box flex align='center' justify='center'>
                  <EnvProvider value={envSelected}>
                    <TriageUrlProvider value={t3Url}>
                      {props.children}
                    </TriageUrlProvider>
                  </EnvProvider>
                </Box>
              </Box>
              <AppFooter />
            </Box>
          )}
        </ResponsiveContext.Consumer>
      </ToastProvider>
    </ >
  )
}

export default Layout;
